var map = {
	"./advertising_0.webp": 77755,
	"./alexa_audio_bg.webp": 61358,
	"./amazon_store_0.webp": 49959,
	"./legal_0.webp": 24940,
	"./luxury_0.webp": 26800,
	"./luxury_1_qr.webp": 54047,
	"./news_1.webp": 37561,
	"./reviews_0.webp": 50100,
	"./social_0.webp": 23474,
	"./social_1.webp": 48189,
	"./sponsored_brands_0.webp": 76927,
	"./vetraai_logo_advertising_1.webp": 62501,
	"./vetraai_logo_alexa.webp": 4164,
	"./vetraai_logo_social_1.webp": 18646,
	"./vetraai_logo_white.webp": 52778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72944;